import React from 'react'
import { ApiError } from 'EstraSuppliers'
import { GetDataError } from 'restful-react'
import styled from 'styled-components'
import { Text } from 'app/components/ui/Text'

interface Props {
  error?: GetDataError<ApiError> | null
  customMessage?: string
  mt?: number
  outline?: boolean
  className?: string
}

export const ApiErrorMessage: React.FC<Props> = ({
  error,
  customMessage,
  mt,
  outline,
  className,
}) => {
  if (customMessage) {
    return (
      <ApiErrorWrapper mt={mt} outline={outline} className={className}>
        <Text variant='s12'>{customMessage}</Text>
      </ApiErrorWrapper>
    )
  }

  if (!error || (error && error.data && typeof error.data === 'string')) {
    return (
      <ApiErrorWrapper mt={mt} outline={outline} className={className}>
        <Text variant='s12'>Si è verificato un Errore.</Text>
      </ApiErrorWrapper>
    )
  }

  const apiReturnedErrorMessages = error.data as ApiError
  return Object.keys(apiReturnedErrorMessages).length ? (
    <ApiErrorWrapper mt={mt} outline={outline} className={className}>
      {error && error.status
        ? Object.keys(apiReturnedErrorMessages).map(err => {
            const message = Array.isArray(apiReturnedErrorMessages[err])
              ? (apiReturnedErrorMessages[err] as []).join(', ')
              : apiReturnedErrorMessages[err]
            return (
              <Text key={err} variant='s12'>
                {err === 'errors' ? 'Errore' : err} {message}
              </Text>
            )
          })
        : null}
    </ApiErrorWrapper>
  ) : null
}

interface ApiErrorWrapperProps {
  outline?: boolean
  mt?: number
}

const ApiErrorWrapper = styled.div<ApiErrorWrapperProps>`
  padding: 0.3rem 0.5rem;
  border-radius: 0.5rem;
  border: ${({ theme, outline }) =>
    outline ? `1px solid ${theme.color.primari.arancione}` : null};
  color: ${({ theme }) => theme.color.primari.arancione};
  margin-top: ${props => props.mt || 0}rem;
`
